import React, {useState} from "react";
import { Link, NavLink } from "react-router-dom";
import Search from "../Banner/Search";
import Dropdown from "./Dropdown";
import SideNav from "./SideNav";

import Pixelbay from "../../assets/pixelbay.PNG";
import useWindowWidth from "../../hooks/use-windowWidth";

import { FaBars } from "react-icons/fa";
import classes from "./Header.module.css";

const Header = () => {
  const width = useWindowWidth();
  const [navOpen, setNavOpen] = useState(false);
  const closeNavHandler = () => {
    setNavOpen(false);
  }
  const openNavHandler = (e) => {
    e.preventDefault();
    setNavOpen(true);
  }

  return (
    <>
    {width < 768 && navOpen && <SideNav close={closeNavHandler}/>}
      <div className={classes.nav}>
        <div className={classes[`primary-nav`]}>
          {width < 768 && (
            <button type="button" className={classes.burger} onClick={openNavHandler}>
              <FaBars />
            </button>
          )}
          <Link to="/">
            <div className={classes.logo}>
              <img src={Pixelbay} alt="logo" />
            </div>
          </Link>
          {width > 500 && <Search search="nav" size="19" />}
        </div>

        {width > 768 && (
          <ul className={classes[`secondary-nav`]}>
            <li className={classes.item}>
              <NavLink to="/collections" activeClassName={classes.active} exact>
                Topics
              </NavLink>
            </li>
            <li>
              <Dropdown />
            </li>
          </ul>
        )}
      </div>
      {width < 500 && <Search search="nav" size="19" />}
    </>
  );
};

export default Header;
